// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__1iisn","name":"ConsentHeader_name__1BkLy","birthday":"ConsentHeader_birthday__1etAe","skeleton":"ConsentHeader_skeleton__10tIP"};